//const api = `https://localhost:44339/api/v1`;
const api = `https://torrepizza.azurewebsites.net/api/v1`;
export const AuthApi = `${api}/Auth/login`;
export const UsuarioApi = `${api}/Usuario`;
export const CategoriaApi = `${api}/Categoria`;
export const ProdutoApi = `${api}/Produto`;
export const EstruturaProdutoApi = `${api}/EstruturaProduto`;
export const PedidoApi = `${api}/Pedido`;